import SvgIcoAppStore from './SvgIcoAppStore';

export default SvgIcoAppStore;
